export const SEARCH_QUERY_INITIAL_VALUE: string = "";
